// Shared content for all /organizers landing variants.
// Copy is Ukrainian; brand name is always all-caps "CONFY".

export const AUDIENCE_COUNT = "94 000+";

export const HERO = {
  title: "Усе для організації акредитованих медичних подій",
  subtitle:
    "Від реєстрації до сертифікатів – CONFY закриває повний цикл БПР-заходу на одній платформі. Створюйте подію за хвилини, а не тижні.",
  ctaPrimary: "Створити подію безкоштовно",
  ctaSecondary: "Розрахувати вартість",
};

export const WHY_ITEMS = [
  { title: "Створюйте подію за хвилини", desc: "Сайт заходу, програма, спікери та реєстрація – без розробників і дизайнерів." },
  { title: "Менше адміністративної роботи", desc: "Автоматична реєстрація, підтвердження та керування учасниками." },
  { title: "Сертифікати – автоматично", desc: "Генерація і видача сертифікатів за вашими шаблонами, без ручної розсилки." },
  { title: "Тестування та оцінювання", desc: "Тести з обмеженнями часу і спроб, опитування та збір відгуків." },
  { title: "Записи та матеріали", desc: "Публікуйте відеозаписи й навчальні матеріали з контролем доступу." },
  { title: "Онлайн-оплати", desc: "Продавайте квитки через підключені платіжні системи." },
  { title: "Комунікація з учасниками", desc: "Листи-нагадування, сповіщення про трансляції та сертифікати." },
  { title: "БПР-автоматизація", desc: "Документи, подання та звітність для акредитації – без паперової рутини." },
  { title: "Аналітика участі", desc: "Статистика реєстрацій, відвідування і результатів у реальному часі." },
  { title: `Аудиторія ${AUDIENCE_COUNT} лікарів`, desc: "Публікуйте подію в каталозі CONFY – її побачать зареєстровані медичні працівники." },
];

// Launch offer: first 10 events free for new organizers until the end of 2026.
export const FREE_OFFER = {
  tiersNote:
    "Нові провайдери проводять перші 10 подій безкоштовно – на будь-якому масштабі до 50 000 реєстрацій*",
  kicker: "Пропозиція для нових провайдерів",
  title: "Перші 10 подій – безкоштовно",
  desc: "Ми любимо те, що робимо, і хочемо, щоб ви закохалися в CONFY так само. Тому новим провайдерам даруємо перші 10 подій – проведіть їх у реальній роботі, з усіма можливостями платформи, і переконайтеся самі.",
  points: [
    "До 50 000 реєстрацій на кожну подію",
    "Усі модулі включено – без доплат",
    "Діє до кінця 2026 року",
  ],
  terms: "* Пропозиція діє для нових провайдерів до кінця 2026 року.",
  cta: "Створити першу подію безкоштовно",
};

export const CORE_FEATURES = [
  "Сторінка події",
  "Реєстрація учасників",
  "Гнучкі типи квитків",
  "Промокоди",
  "Керування учасниками",
  "Статистика та аналітика",
  "Експорт учасників",
  "Навчальні матеріали",
  "Відеозаписи",
  "Тестування",
  "Опитування та відгуки",
  "Генерація сертифікатів",
  "Шаблони сертифікатів",
  "Email-автоматизація",
  "QR check-in",
];

export type Tier = {
  id: string;
  limitLabel: string;
  limit: number | null; // null = contact us
  price: number | null; // UAH, null = contact us
  note?: string;
};

export const TIERS: Tier[] = [
  { id: "free", limitLabel: "До 100", limit: 100, price: 0, note: "Приватна подія, без публікації в каталозі" },
  { id: "s", limitLabel: "До 1 000", limit: 1000, price: 2500 },
  { id: "m", limitLabel: "До 10 000", limit: 10000, price: 5000 },
  { id: "l", limitLabel: "До 50 000", limit: 50000, price: 10000 },
  { id: "xl", limitLabel: "Понад 50 000", limit: null, price: null, note: "Звʼяжіться з нами" },
];

export type Addon = {
  id: string;
  title: string;
  desc: string;
  price: number | null; // UAH per event; null = special pricing
  priceLabel: string;
  soon?: boolean;
  options?: { id: string; label: string; price: number }[];
};

export const ADDONS: Addon[] = [
  {
    id: "catalog",
    title: "Публікація в каталозі CONFY",
    desc: `Подія зʼявляється в публічному каталозі та на головній сторінці – її бачить аудиторія з ${AUDIENCE_COUNT} зареєстрованих медичних працівників.`,
    price: 1000,
    priceLabel: "1 000 ₴",
  },
  {
    id: "payments",
    title: "Онлайн-оплати",
    desc: "Продавайте квитки через WayForPay або LiqPay. Без плати за активацію – лише комісія з продажів.",
    price: null,
    priceLabel: "3,8% з продажів",
  },
  {
    id: "bpr",
    title: "БПР-автоматизація",
    desc: "Підготовка документації, подання, відстеження і завантаження результатів – автоматизація повного циклу роботи з МОЗ.",
    price: 1200,
    priceLabel: "1 200 ₴",
  },
  {
    id: "marketing",
    title: "Маркетингові кампанії",
    desc: "Просування події на аудиторію CONFY за спеціальностями: неврологи, кардіологи, стоматологи, сімейні лікарі та інші.",
    price: null,
    priceLabel: "За запитом",
  },
];

// Flat-rate plan for frequent organizers: one monthly payment, everything in.
export const PRO_PLAN = {
  id: "pro",
  kicker: "Для частих організаторів",
  title: "PRO – все включено",
  desc: "Організовуєте події щомісяця? Замість оплати за кожну подію окремо – один фіксований платіж, який покриває все: усі модулі та реєстрації без доплат.",
  priceMonthly: 30000,
  eventsPerMonth: 30,
  perEvent: 1000,
  points: [
    "До 30 подій на місяць",
    "До 50 000 реєстрацій на кожну подію",
    "Усі модулі включено: каталог CONFY і БПР-автоматизація",
    "Жодних доплат – одна ціна на все",
  ],
  note: "Онлайн-оплати – з комісією 3,8% з продажів, як і в усіх тарифах.",
  mailSubject: "Тариф PRO – все включено",
};

export const WALLET = {
  title: "Баланс організатора",
  desc: "Поповніть баланс один раз – далі все відбувається автоматично: підвищення тарифу, купівля модулів, активація послуг. Жодних рахунків на кожну дрібницю.",
  points: [
    "Реєстрація ніколи не зупиняється",
    "Автоматичне підвищення тарифу – доплачуєте лише різницю",
    "Модулі вмикаються в один клік",
    "Простіша бухгалтерія",
  ],
};

export const AUTOSCALE = {
  title: "Реєстрація не зупиняється",
  desc: "Коли кількість реєстрацій перевищує обраний тариф, подія автоматично переходить на наступний. З балансу списується лише різниця між тарифами, а ви отримуєте сповіщення.",
  example: ["Безкоштовно (до 100)", "101-ша реєстрація", "Автоматичне підвищення", "З балансу списано 2 500 ₴"],
};

export const FUTURE_ADDONS = [
  "Віджет реєстрації для вашого сайту",
  "Мобільний додаток",
  "AI-конспекти доповідей",
  "Модулі для спонсорів",
  "Друк бейджів",
  "Розширена аналітика",
  "Керування спікерами",
  "Персональний менеджер",
  "Пріоритетна підтримка",
];

export const CONTACT = {
  email: "support@confy.cc",
  platformUrl: "https://confy.cc",
  registerUrl: "https://confy.cc/login",
};

// Estimator helpers -------------------------------------------------------

export function formatUAH(n: number): string {
  return n.toLocaleString("uk-UA").replace(/,/g, " ") + " ₴";
}

export type EstimatorAddonState = {
  catalog: boolean;
  // email/qr are part of the base platform now; fields kept only so the
  // archived _variants pages still type-check.
  email: boolean;
  payments: boolean;
  bpr: false | "standard" | "training";
  qr: boolean;
};

export function estimateTotal(tier: Tier, addons: EstimatorAddonState): number | null {
  if (tier.price === null) return null;
  let total = tier.price;
  if (addons.catalog) total += 1000;
  if (addons.bpr) total += 1200;
  return total;
}
